/**
 * Native platform reported by the React Native shell via NATIVE_APP_INFO.
 * Prefer this over User-Agent sniffing (WebView UA can be misleading).
 */
let nativePlatform: 'ios' | 'android' | null = null;

export function setNativeAppPlatform(platform: unknown): void {
  if (platform === 'ios' || platform === 'android') {
    nativePlatform = platform;
  }
}

export function getNativeAppPlatform(): 'ios' | 'android' | null {
  return nativePlatform;
}

export function detectNativeDeviceType(): 'IOS' | 'ANDROID' {
  if (nativePlatform === 'ios') return 'IOS';
  if (nativePlatform === 'android') return 'ANDROID';

  const ua = typeof navigator !== 'undefined' ? navigator.userAgent : '';
  if (ua.includes('iPhone') || ua.includes('iPad') || ua.includes('iPod')) {
    return 'IOS';
  }
  return 'ANDROID';
}
